import React, { useEffect, useState } from 'react';

import { replaceUnderLine } from '@utils/Util';

const AddedColors = ({
	colorGroupResponseList,
	colorResponse,
	colorType,
	viewType = 'tableView',
	showPopup = true,
	isShowColorName = true
}) => {
	const [pantoneColorList, setPantoneColorList] = useState([]);

	useEffect(() => {
		if (colorResponse !== undefined && Object.keys(colorResponse).length !== 0) {
			if (colorType === 'SOLID') {
				setPantoneColorList([colorResponse]);
			} else {
				setPantoneColorList(colorResponse?.compositeColorList);
			}
		} else {
			setPantoneColorList([]);
		}
	}, [colorResponse, colorType]);

	const renderGroupColorList = () => {
		return colorGroupResponseList?.map((item) => (
			<li className="d-flex justify-content-start align-items-center" key={`key_${item?.id}`}>
				{showPopup && <span className="color-icon mr-1" style={{ background: `${item?.hexCode}` }} />}
				{isShowColorName && <span className="code gray_dark_02 regular-14">{item?.name}</span>}
			</li>
		));
	};
	const renderPantoneColorList = () => {
		return pantoneColorList?.map((item) => (
			<li key={`key_${item?.id}`}>
				{viewType === 'tableView' && (
					<div className="d-flex justify-content-start align-items-center">
						<span className="code gray_dark_02 regular-14">{item?.name}</span>
					</div>
				)}
				<div className="d-flex align-items-center">
					{showPopup && (
						<span className="color-icon mr-1" style={{ background: `${item?.hexCode}` }} />
					)}
					{isShowColorName && (
						<span className="code gray_dark_02 regular-14">
							{viewType === 'tableView' ? item?.code : item?.name}
						</span>
					)}
				</div>
			</li>
		));
	};

	const renderPantoneColorListOnPopup = () => {
		return pantoneColorList?.map((item) => (
			<div className="single-color-item">
				<span className="color-view" style={{ background: `${item?.hexCode}` }}></span>
				<p className="regular-12 gray_dark_02">{item?.name}</p>
				<p className="regular-12 weight-500 gray-dark-02">{item?.code}</p>
			</div>
		));
	};

	const renderGroupColorListOnPopup = () => {
		return colorGroupResponseList?.map((item) => (
			<div className="single-color-item">
				<span className="color-view" style={{ background: `${item?.hexCode}` }}></span>
				<p className="regular-12 gray_dark_02">{item?.name}</p>
				<p className="regular-12 weight-500 gray-dark-02">{item?.code}</p>
			</div>
		));
	};

	return (
		<div className="added-material-colors">
			{viewType === 'tableView' && colorType !== 'SOLID' && (
				<p className="regular-12 weight-700 gray_dark_01 mb-1 color-type">
					{replaceUnderLine(colorType, true)}
				</p>
			)}
			<div className="all-color-code">
				<ul className={`d-flex gap-1 flex-wrap ${viewType === 'tableView' ? 'hide-bullets' : ''}`}>
					{pantoneColorList?.length > 0 ? renderPantoneColorList() : renderGroupColorList()}
				</ul>
			</div>
			{showPopup && (
				<div className="added-colors-popup">
					<div className="added-color-list">
						{viewType === 'baseColorView' && pantoneColorList?.length === 0
							? renderGroupColorListOnPopup()
							: renderPantoneColorListOnPopup()}
					</div>
					{viewType !== 'baseColorView' && pantoneColorList?.length === 0 && (
						<div className="no-color-state">
							<p className="regular-12 gray_dark_02 pt-0">No TCX Color selected</p>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default AddedColors;
